import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import './Home.css';

const Home = () => {
  const navigate = useNavigate();

  const handleQueroVender = () => {
    navigate('/registro');
  };

  const heroStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/logo/hero_background.png)`,
  };

  return (
    <div className="home-page">
      <Header />

      <main className="main-content">
        {/* Hero Section */}
        <section className="hero-section" style={heroStyle}>
          <div className="hero-background">
            <div className="container">
              <div className="hero-content">
                {/* Two-column layout: Platform message (left) + 5 Dias (right) */}
                <div className="hero-two-columns">
                  {/* Left Column - Platform Message */}
                  <div className="platform-message">
                    <h2 className="platform-title">
                      Somos uma plataforma de inteligência artificial desenvolvida para transformar a gestão de precatório
                    </h2>
                    <div className="platform-description">
                      <p className="platform-intro">
                        A <strong>MICA CAPITAL</strong> integra tecnologias avançadas de automação e análise de dados para conduzir todo o ciclo de ponta a ponta, desde a captura inteligente de informações até a conclusão dos negócios.
                      </p>
                      <p className="platform-benefit">
                        Ao substituir processos manuais por fluxos digitais inteligentes, oferecemos ganhos expressivos em velocidade, precisão e escalabilidade.
                      </p>
                      <p className="platform-result">
                        Isso libera tempo dos profissionais para se dedicar ao relacionamento com clientes e às decisões estratégicas, enquanto a tecnologia assegura eficiência operacional e maior retorno sobre o investimento.
                      </p>
                    </div>
                  </div>

                  {/* Right Column - 5 Dias CTA */}
                  <div className="hero-cta-box">
                    <div className="hero-badge">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"/>
                      </svg>
                      Tecnologia de IA
                    </div>

                    <h1 className="hero-title">
                      Dinheiro na mão em até<br />
                      <span className="highlight-text">5 Dias</span> do início do Cadastro
                    </h1>

                    <p className="hero-subtitle">
                      Nossa Inteligência Artificial analisa seu precatório e gera propostas em tempo recorde. Do cadastro ao dinheiro na conta: processo 100% digital e sem burocracia.
                    </p>

                    <div className="hero-features">
                      <div className="feature-badge">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                        </svg>
                        Análise por IA
                      </div>
                      <div className="feature-badge">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                        </svg>
                        Dinheiro em 5 Dias
                      </div>
                      <div className="feature-badge">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                        </svg>
                        100% Seguro
                      </div>
                    </div>

                    <button className="btn btn-primary btn-large" onClick={handleQueroVender}>
                      Quero Meu Dinheiro em 5 Dias
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* AI Technology Section */}
        <section className="ai-technology-section">
          <div className="container">
            <h2 className="section-title">Tecnologia que Acelera Resultados</h2>
            <p className="section-subtitle">Nossa Inteligência Artificial analisa precatórios em tempo recorde</p>

            <div className="ai-grid">
              <div className="ai-card">
                <div className="ai-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M20 3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h3l-1 1v2h12v-2l-1-1h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H4V5h16v11z"/>
                  </svg>
                </div>
                <h3>Análise Instantânea</h3>
                <p>IA processa e valida documentos automaticamente em minutos</p>
              </div>

              <div className="ai-card ai-card-highlight">
                <div className="ai-badge">Diferencial</div>
                <div className="ai-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3>Dinheiro em 5 Dias</h3>
                <p>Do cadastro ao pagamento em apenas 5 dias úteis</p>
              </div>

              <div className="ai-card">
                <div className="ai-icon">
                  <svg width="50" height="50" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>100% Digital</h3>
                <p>Sem burocracia, tudo online com total segurança jurídica</p>
              </div>
            </div>
          </div>
        </section>

        {/* Credibility Section */}
        <section className="credibility-section">
          <div className="container">
            <h2 className="section-title">Por Que Confiar na MICA Capital?</h2>
            
            <div className="credibility-grid">
              <div className="credibility-card">
                <div className="credibility-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"/>
                  </svg>
                </div>
                <h3>Tecnologia de IA</h3>
                <p>Análise automatizada garante precisão e agilidade incomparáveis. Nossa IA processa seu precatório em minutos, não meses.</p>
              </div>

              <div className="credibility-card">
                <div className="credibility-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                  </svg>
                </div>
                <h3>Dinheiro em 5 Dias</h3>
                <p>Do cadastro ao dinheiro na conta em 5 dias. Enquanto outros levam meses, seu dinheiro está na mão em dias.</p>
              </div>

              <div className="credibility-card">
                <div className="credibility-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                  </svg>
                </div>
                <h3>Experiência Comprovada</h3>
                <p>10 anos no mercado + tecnologia de ponta = a melhor combinação para suas negociações de precatórios.</p>
              </div>

              <div className="credibility-card">
                <div className="credibility-icon">
                  <svg width="60" height="60" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Transparência Total</h3>
                <p>Acompanhe cada etapa do processo online. Segurança jurídica e clareza em todas as transações.</p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works Section */}
        <section className="how-it-works-section">
          <div className="container">
            <h2 className="section-title">Como Funciona?</h2>
            <p className="section-subtitle">Do cadastro ao dinheiro na conta em tempo recorde</p>

            <div className="steps-container">
              <div className="step-item">
                <div className="step-timeline">
                  <div className="step-number">1</div>
                  <div className="step-time">Imediato</div>
                </div>
                <h3>Cadastro Online</h3>
                <p>Cadastre seu precatório em minutos pelo nosso sistema 100% digital</p>
              </div>

              <div className="step-arrow">→</div>

              <div className="step-item">
                <div className="step-timeline">
                  <div className="step-number">2</div>
                  <div className="step-time">24-48h</div>
                </div>
                <h3>Análise por IA</h3>
                <p>Nossa Inteligência Artificial analisa e valida automaticamente todos os dados</p>
              </div>

              <div className="step-arrow">→</div>

              <div className="step-item step-item-highlight">
                <div className="step-timeline">
                  <div className="step-number">3</div>
                  <div className="step-time">Até 5 dias</div>
                </div>
                <h3>Proposta Comercial</h3>
                <p>Receba a melhor oferta do mercado para seu precatório</p>
              </div>

              <div className="step-arrow">→</div>

              <div className="step-item">
                <div className="step-timeline">
                  <div className="step-number">4</div>
                  <div className="step-time">Após aprovação</div>
                </div>
                <h3>Dinheiro na Conta</h3>
                <p>Receba o valor à vista rapidamente e sem burocracia</p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <div className="container">
            <div className="cta-content">
              <h2>Não Fique Mais Anos Esperando pelo Governo</h2>
              <p className="cta-highlight">Com nossa IA, você tem seu dinheiro em <strong>5 dias</strong> do cadastro ao pagamento.</p>
              <p>Pare de esperar. Transforme seu precatório em dinheiro na mão agora.</p>
              <button className="btn btn-secondary btn-large" onClick={handleQueroVender}>
                Quero Meu Dinheiro em 5 Dias
              </button>
            </div>
          </div>
        </section>
      </main>
      
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2024 MICA Capital - Ativos Judiciais. Todos os direitos reservados.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
